import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=504e593c&scoped=true&"
import script from "./ErrorList.js?vue&type=script&lang=js&"
export * from "./ErrorList.js?vue&type=script&lang=js&"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=504e593c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e593c",
  null
  
)

export default component.exports